const getFormattedFilename = (input) => {
  let string = input.toLowerCase();
  string = string.split(' ').join('-');
  string = string.split('&').join('en');
  string = string.split('--').join('-');
  string = string.split('°').join('');

  return string;
}

export default getFormattedFilename;